import { render, staticRenderFns } from "./addtestcreate.vue?vue&type=template&id=679d04d7&scoped=true&"
import script from "./addtestcreate.vue?vue&type=script&lang=js&"
export * from "./addtestcreate.vue?vue&type=script&lang=js&"
import style0 from "./addtestcreate.vue?vue&type=style&index=0&id=679d04d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d04d7",
  null
  
)

export default component.exports